import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import { HashRouter } from "react-router-dom";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import routes from "./constants/routes";

ReactDOM.render(
  <React.StrictMode>
    <HashRouter basename={routes.HOME}>
      <App />
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
